import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Avatar,
  Typography,
  Input,
  Select,
} from "antd";
import { PlusOutlined, SearchOutlined, ToTopOutlined } from "@ant-design/icons";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";
import Spinner from "../components/common/Spinner/Spinner";
import jwtDecode from "jwt-decode";
import { v4 as uuidv4 } from "uuid";

const { Title } = Typography;

// table code start
const columns = [
  {
    title: "USER",
    dataIndex: "name",
    key: "name",
    width: "32%",
  },

  {
    title: "ACTIVE",
    key: "status",
    dataIndex: "status",
  },

  {
    title: "NEEDS NFC",
    key: "needsNFC",
    dataIndex: "needsNFC",
  },

  {
    title: "EDIT USER",
    key: "edit",
    dataIndex: "edit",
  },
  // {
  //   title: "COMPANY",
  //   key: "company",
  //   dataIndex: "company",
  // },
];

const societatiPaza = [
  {
    label: "All Companies",
    value: "All Companies",
  },
  {
    label: "AKB SECURITY",
    value: "AKB SECURITY",
  },
  {
    label: "ELNET SECURITY",
    value: "ELNET SECURITY",
  },
  {
    label: "ORION SECURITY",
    value: "ORION SECURITY",
  },
  {
    label: "RPG SECURITY",
    value: "RPG SECURITY",
  },
  {
    label: "SSG SECURITY",
    value: "SSG SECURITY",
  },
  {
    label: "SSG FIRE&RESCUE",
    value: "SSG FIRE&RESCUE",
  },
  {
    label: "HIGHLANDER GUARD",
    value: "HIGHLANDER GUARD",
  },
];

const needsNFC = [
  {
    label: "All Users",
    value: "All Users",
  },
  {
    label: "Needs NFC",
    value: "true",
  },
  {
    label: "Does not need NFC",
    value: "false",
  },
];

function Users() {
  const history = useHistory();
  const location = useLocation();

  const [token, setToken] = useState(localStorage.getItem("token"));

  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState();

  const [selectedCompany, setSelectedCompany] = useState("All Companies");

  const [selectedNFC, setSelectedNFC] = useState("All Users");

  const [query, setQuery] = useState("");

  const data = users
    ?.filter((user) =>
      query === ""
        ? user
        : user.username.toLowerCase().includes(query.toLowerCase())
    )
    .filter((user) =>
      selectedCompany === "All Companies"
        ? user
        : user.company === selectedCompany
    )
    .filter((user) =>
      selectedNFC === "All Users"
        ? user
        : user.needsNFC.toString() === selectedNFC.toString()
    )
    .map((user) => {
      return {
        key: user?.id,
        name: (
          <>
            <Avatar.Group>
              {/*<Avatar*/}
              {/*  className="shape-avatar"*/}
              {/*  shape="square"*/}
              {/*  size={40}*/}
              {/*  src={face}*/}
              {/*></Avatar>*/}
              <div className="avatar-info">
                <Title level={5}>{user?.username}</Title>
                <p>{user?.email}</p>
              </div>
            </Avatar.Group>{" "}
          </>
        ),
        // function: (
        //   <>
        //     <div className="author-info">
        //       <Title level={5}>Inspector</Title>
        //       <p>Premium Security</p>
        //     </div>
        //   </>
        // ),

        status: (
          <>
            <Button
              className={user?.active ? "tag-primary" : "tag-badge"}
              style={{ cursor: "auto" }}
            >
              {user?.active ? <span>TRUE</span> : <span>FALSE</span>}
            </Button>
          </>
        ),

        needsNFC: (
          <>
            <Button
              className={user?.needsNFC ? "tag-primary" : "tag-badge"}
              style={{ cursor: "auto" }}
            >
              {user?.needsNFC ? <span>TRUE</span> : <span>FALSE</span>}
            </Button>
          </>
        ),
        // company: (
        //   <>
        //     <div className="ant-employed">
        //       <span>{user?.company}</span>
        //       <Link
        //         style={{ marginLeft: "10px", color: "#1EC8FF" }}
        //         to={`user/${user?.id}`}
        //       >
        //         Edit
        //       </Link>
        //     </div>
        //   </>
        // ),
        edit: (
          <>
            <div className="ant-employed">
              {/*<span>{user?.company}</span>*/}
              <Link
                style={{ marginLeft: "10px", color: "#1EC8FF" }}
                to={`user/${user?.id}`}
              >
                Edit
              </Link>
            </div>
          </>
        ),
      };
    });

  const getUsers = async () => {
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "user/getAllUsers",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);
      setUsers(
        response.data.filter((user) => user.roles.includes("ROLE_USER"))
      );

      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const exportUsers = async () => {
    const token = localStorage.getItem("token");

    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL +
          "csvExport/exportUsersToCSV?separator=%2C",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "text/csv",
            "Content-Type": "application/json",
          },
          responseType: "blob",
        }
      );

      const blob = new Blob([response.data], { type: "text/csv" });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;

      link.setAttribute("download", "users.csv");

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.log(e);
    }
  };

  const handleChange = (value) => {
    console.log(`selected ${value}`);
    setSelectedCompany(value);
  };

  const handleChangeNFC = (value) => {
    console.log(`selected ${value}`);
    setSelectedNFC(value);
  };

  useEffect(() => {
    let currentDate = new Date();
    setToken(localStorage.getItem("token"));
    console.log("app token", token);
    if (
      (token && jwtDecode(token).exp * 1000 < currentDate.getTime()) ||
      token === null
    ) {
      history.push("/sign-in");
    } else {
      history.push(location.pathname);
    }
  }, [token]);

  useEffect(() => {
    getUsers();
  }, []);

  return (
    <>
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Users"
              extra={
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                  }}
                >
                  {/*<Select*/}
                  {/*  // defaultValue={societatiPaza[0].value}*/}
                  {/*  value={selectedCompany}*/}
                  {/*  style={{*/}
                  {/*    width: 200,*/}
                  {/*    marginRight: "10px",*/}
                  {/*    height: "100%",*/}
                  {/*    marginBottom: "10px",*/}
                  {/*    marginTop: "10px",*/}
                  {/*  }}*/}
                  {/*  onChange={handleChange}*/}
                  {/*  options={societatiPaza}*/}
                  {/*/>*/}

                  <Select
                    value={selectedNFC}
                    style={{
                      width: 200,
                      marginRight: "10px",
                      height: "100%",
                      marginBottom: "10px",
                      marginTop: "10px",
                    }}
                    onChange={handleChangeNFC}
                    options={needsNFC}
                  />

                  <Input
                    style={{
                      marginRight: "10px",
                      width: "200px",
                      marginBottom: "10px",
                      marginTop: "10px",
                    }}
                    size="small"
                    prefix={
                      <SearchOutlined
                        size="small"
                        // style={{
                        //   backgroundColor: "red",
                        //   padding: "0px",
                        //   margin: "0px",
                        //   height: "10px",
                        // }}
                        className="site-form-item-icon"
                      />
                    }
                    placeholder="Search user"
                    onChange={(e) => setQuery(e.target.value)}
                    // style={{ width: 150, height: "100%" }}
                  />
                  <NavLink
                    to="/add-user"
                    style={{
                      marginBottom: "10px",
                      marginTop: "10px",
                      marginRight: "10px",
                    }}
                  >
                    <Button type="secondary" className="tag-primary">
                      <PlusOutlined />
                      Add User
                    </Button>
                  </NavLink>
                  <Button
                    onClick={() => exportUsers()}
                    style={{ marginBottom: "10px", marginTop: "10px" }}
                    type="secondary"
                    className="tag-secondary"
                  >
                    Export Users
                  </Button>
                  {/*<Input*/}
                  {/*  style={{ marginLeft: "20px" }}*/}
                  {/*  className="header-search"*/}
                  {/*  placeholder="Type here..."*/}
                  {/*  prefix={<SearchOutlined />}*/}
                  {/*/>*/}
                  {/*<Radio.Group style={{display: "flex", flexDirection: "row"}} onChange={onChange} defaultValue="a">*/}
                  {/*  <Radio.Button value="a">All</Radio.Button>*/}
                  {/*  <Radio.Button value="b">ONLINE</Radio.Button>*/}
                  {/*</Radio.Group>*/}
                </div>
              }
            >
              <div className="table-responsive">
                {loading ? (
                  <Spinner />
                ) : (
                  <Table
                    style={{ padding: "10px" }}
                    columns={columns}
                    dataSource={data}
                    pagination={true}
                    className="ant-border-space"
                  />
                )}
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Users;
